import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const secureStorage = {
  setItem(key, value) {
    localStorage.setItem(key, value);
  },
  getItem(key) {
    return localStorage.getItem(key);
  },
  removeItem(key) {
    localStorage.removeItem(key);
  }
};

const useGlobale = create(
  persist(
    (set) => ({
      authenticated_anpe: false,
      user: null,
      _hasHydrated: false,
      setHasHydrated: (state) => set({ _hasHydrated: state }),

      updateUserInfo: (updatedUserData) => {
        set(state => ({
          ...state,
          user: {
            ...state.user,
            ...updatedUserData,
            // Assurez-vous que photo_url est également mis à jour
            photo_url: updatedUserData.photo_url || state.user?.photo_url
          }
        }));
      },

      setUser: (newUserData) => {
        set(state => ({
          ...state,
          user: newUserData
        }));
      },

      login: async (tokens, user) => {
        try {
          const authData = {
            access: tokens.access,
            refresh: tokens.refresh
          };

          secureStorage.setItem('auth_tokens', JSON.stringify(authData));
          
          const safeUserInfo = { ...user };
          if (safeUserInfo.password) delete safeUserInfo.password;
          
          set({
            authenticated_anpe: true,
            user: safeUserInfo,
          });
        } catch (error) {
          console.error('Error during login:', error);
        }
      },

      logout: async () => {
        try {
          secureStorage.removeItem('auth_tokens');
          set({
            authenticated_anpe: false,
            user: null,
          });
        } catch (error) {
          console.error('Error during logout:', error);
        }
      },

      checkAuth: async () => {
        try {
          const tokensString = secureStorage.getItem('auth_tokens');
          if (tokensString) {
            const tokens = JSON.parse(tokensString);
            set({ authenticated_anpe: !!tokens.access });
          } else {
            set({ authenticated_anpe: false, user: null });
          }
        } catch (error) {
          console.error('Error checking auth:', error);
          set({ authenticated_anpe: false, user: null });
        }
      },

      updateUserPhoto: (photoData) => {
        set(state => ({
          ...state,
          user: {
            ...state.user,
            photo: photoData.photo,
            photo_url: photoData.photo_url
          }
        }));
      },
    }),
    {
      name: 'auth-storage',
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);

export default useGlobale;